import * as React from 'react';
import type { SVGProps } from 'react';
const CaretUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 256 256"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M216.49 168.49C215.375 169.609 214.051 170.496 212.592 171.102C211.133 171.708 209.569 172.02 207.99 172.02C206.411 172.02 204.847 171.708 203.388 171.102C201.93 170.496 200.605 169.609 199.49 168.49L128 97L56.4901 168.49C54.2357 170.744 51.1782 172.011 47.9901 172.011C44.8019 172.011 41.7444 170.744 39.4901 168.49C37.2357 166.236 35.9692 163.178 35.9692 159.99C35.9692 156.802 37.2357 153.744 39.4901 151.49L119.49 71.49C120.605 70.3713 121.93 69.4837 123.388 68.878C124.847 68.2723 126.411 67.9606 127.99 67.9606C129.569 67.9606 131.133 68.2723 132.592 68.878C134.05 69.4837 135.375 70.3713 136.49 71.49L216.49 151.49C217.609 152.605 218.496 153.93 219.102 155.388C219.708 156.847 220.02 158.411 220.02 159.99C220.02 161.569 219.708 163.133 219.102 164.592C218.496 166.05 217.609 167.375 216.49 168.49Z"
      fill="currentColor"
    />
  </svg>
);
export default CaretUp;
